import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = ["onUpdate:modelValue", "value", "onChange"]
const _hoisted_2 = ["onUpdate:modelValue", "onChange"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["onUpdate:modelValue", "min", "max", "step", "onBlur"]
const _hoisted_5 = { class: "option-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkboxList, (item) => {
      return (_openBlock(), _createElementBlock("label", {
        key: item.name
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": ($event: any) => ((_ctx.conditionValues[item.name]) = $event),
          value: item,
          onChange: ($event: any) => (_ctx.valueOnChange($event, item))
        }, null, 40, _hoisted_1), [
          [_vModelCheckbox, _ctx.conditionValues[item.name]]
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.name)), 1)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectList, (item) => {
      return (_openBlock(), _createElementBlock("label", {
        key: item.name
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.name)), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": ($event: any) => ((_ctx.conditionValues[item.name]) = $event),
          onChange: ($event: any) => (_ctx.valueOnChange($event, item))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: index,
              key: option
            }, _toDisplayString(_ctx.displayOptionName(option)), 9, _hoisted_3))
          }), 128))
        ], 40, _hoisted_2), [
          [_vModelSelect, _ctx.conditionValues[item.name]]
        ])
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberList, (item) => {
      return (_openBlock(), _createElementBlock("label", {
        class: "condition",
        key: item.name
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.name)), 1),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": ($event: any) => ((_ctx.conditionValues[item.name]) = $event),
          min: item.min,
          max: item.max,
          step: item.step,
          onBlur: ($event: any) => (_ctx.valueOnChange($event, item))
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.conditionValues[item.name]]
        ])
      ]))
    }), 128)),
    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayStatAjustmentList, (item) => {
        return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}